export const promised = inner => (...args) => Promise
  .resolve(inner.call(undefined, ...args))
  .then(() => Promise.resolve(...args));
